import * as React from 'react'
import { FileText } from 'react-feather'

import { palette } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { i18nKeyPrefix } from '../i18n'
import { Container, HandbookNativeLink } from './Handbook.styles'

const PRE = `${i18nKeyPrefix}-HANDBOOK`

interface IProps {
  path: string | undefined
}

export default function Handbook(props: IProps) {
  const { path } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Container>
      <FileText color={palette.mediumGray} />
      <HandbookNativeLink rel="nofollow" href={path} target="_blank">
        {t(`${PRE}-LINK`)}
      </HandbookNativeLink>
    </Container>
  )
}
